// =====================================
//
//   建立模板 Modal
//   Author: Gray
//   createtime: 2017 / 05 / 22
//   updatetime: 2017 / 05 / 22
//
// =====================================

window.InifECApp.directive('createOrderTemplate', ['$rootScope', '$ngModal', '$timeout', 'ProductService', '$state', 'TemplateService', 'OrderService', '$ProductFormatService',
	function ($rootScope, $ngModal, $timeout, ProductService, $state, TemplateService, OrderService, $ProductFormatService) {

		var _dir = {};

		var link = function(scope, element, attrs) {}

		var controller = ['$scope', '$element', function($scope, $element) {

			var openModal = function() {

				$ngModal.openModal("create-order-template");
				$element.find('.content').scrollTop(0);
			}

			var closeModal = function() {

				$ngModal.closeModal("create-order-template");
			}

			var getPdtClassList = function(orderitem) {

				if($scope.isLoading || $scope.isLoaded) {
					return;
				}

            	$scope.isLoading = true;
	            ProductService.getPdtClassList().then(function(result) {
	                if(result) {

	                	$scope.pdtClassList = $ProductFormatService.getPdtClassList('MODAL');

	                	if(!$scope.pdtClassList || $scope.pdtClassList.length == 0) {
	                		var _result = shallowCopy(result);

	                    	$scope.pdtClassList = $ProductFormatService.formatModalPdtClassList(_result);
	                    }
	                    getPdtClassListSuccess(orderitem);
	                }

	                $scope.isLoaded = true;
	                $scope.isLoading = false;
	            }, function(error) {
	                $scope.isLoading = false;
	                $scope.isError = true;
	            });
	        }

	        var getPdtClassListSuccess = function(orderitem) {

	        	if($scope.pdtClassList.length > 0) {
                	if(!$scope.form.mainPdtClass) {
                		changeMainPdtClass($scope.pdtClassList[0]);
                	}

                	if(orderitem) {
                		getOrderItem(orderitem);
                		changeViewType('product');
                	}
                }
	        }

			var changeMainPdtClass = function(mainPdtClass){
				if($scope.form.mainPdtClass == mainPdtClass){
					return;
				}

				$scope.form.mainPdtClass = mainPdtClass;

				if($scope.form.pdtClass) {
					changePdtClass(mainPdtClass.pdtClasses[0]);
				}
			}

			var changePdtClass = function(pdtClass) {
				if($scope.form.pdtClass == pdtClass) {
					return;
				}

				$scope.form.pdtClass = pdtClass;

				if($scope.form.product) {
					changeProduct(pdtClass.products[0]);
				}
			}

			var changeProduct = function(product) {

				if($scope.form.product == product) {
					return;
				}

				$scope.form.product = product;
			}

			var templateCallback = function(template) {

				if(template) {
					$scope.callback && $scope.callback(template);
				}

				closeModal();
			}

			var changeSelectOrderView = function(orderid, orderitemid, callback) {

				resetSelect();

				if($scope.orders.length == 0) {
					$scope.isOrderLoading = false;
					$scope.isOrderNoMore = false;
					$scope.isOrderEmpty = false;
					getHistoryOrderList();
				} else {

					for(var i = 0; i < $scope.orders.length; i++) {
						var order = $scope.orders[i];

						if(order.orderid == orderid) {
							selectOrder(order);

							for(var j = 0; j < order.orderitems; j++) {
								var orderitem = order.orderitems[j];
								if(orderitem.orderitemid == orderitemid) {
									selectOrderItem(orderitem);
									break;
								}
							}
							break;
						}
					}
				}

				$scope.selectOrderFileCallback = callback;
				changeViewType("orderfile");
			}

			var changeViewType = function(viewtype, viewWithoutAnimation) {

				$scope.viewWithoutAnimation = viewWithoutAnimation;
				$scope.form.viewtype = viewtype;
			}

			var getHistoryOrderList = function() {

				if($scope.isOrderLoading || $scope.isOrderNoMore || $scope.isOrderEmpty) {
				    return;
				}

				$scope.isOrderLoading = true;

				OrderService.getOrderListWithStatus(700, $scope.start, $scope.len).then(function(result){

					if(Array.isArray(result) && result.length > 0) {
						for(var i = 0 ; i < result.length ; i++){
						    var _order = result[i];

						    $scope.orders.push(_order);
						}
					} else if ($scope.orders.length > 0) {
	                    $scope.isOrderNoMore = true;
	                } else if ($scope.orders.length == 0) {
	                    $scope.isOrderEmpty = true;
	                }

	                $scope.start += $scope.len;

	                $scope.isOrderLoading = false;
				}, function(error) {

					$scope.isOrderLoading = true;
					$scope.isOrderError = false;
				});
			}

			var getOrderItemCoverImage = function(orderitem) {

			    if(!orderitem || !orderitem.coverurl){
			        return "about:blank";
			    }

			    return orderitem.coverurl;
			}

			var getOrderItemFileImage = function(orderitem) {

			    if(!orderitem || !orderitem.file || !orderitem.file.filename){
			        return "about:blank";
			    }

			    var filename = orderitem.file.filename;
			    var filetype = filename.substr(filename.lastIndexOf('.'));
			    var imageurl = "./images/";

			    switch(filetype) {
			    	case 'ai':
			    		imageurl += 'file-ai.png';
			    		break;
			    	case 'pdf':
			    		imageurl += 'file-pdf.png';
			    		break;
			    	case 'zip':
			    		imageurl += 'file-zip.png';
			    		break;
			    	default:
			    		imageurl += 'file.png';
			    		break;
			    }

			    return imageurl;
			}

			var selectOrder = function(order) {

				$scope.currentOrder = order;
			}

			var selectOrderItem = function(orderitem) {

				$scope.currentOrderitem = orderitem;
			}

			var resetSelect = function() {

				$scope.currentOrder = undefined;
				$scope.currentOrderitem = undefined;
			}

			var resetVar = function() {

				$scope.form.mainPdtClass = undefined;
				$scope.form.pdtClass = undefined;
				$scope.form.product = undefined;
				$scope.form.templateName = undefined;
				$scope.form.specInitOrderitem = undefined;
			}

			// --------------------------------
			// 取得下載網址
			// --------------------------------
			var getDownloadUrl = function(url) {

			    return url;
			}

			var finishSelectOrderFile = function() {

				if(!$scope.currentOrder || !$scope.currentOrderitem) {
					return;
				}

				if($scope.selectOrderFileCallback) {
					var orderid = $scope.currentOrder.orderid;
					var orderitemid = $scope.currentOrderitem.orderitemid;
					var filename = $scope.currentOrderitem.file ? $scope.currentOrderitem.file.filename : '';

					$scope.selectOrderFileCallback(orderid, orderitemid, filename)
				}

				changeViewType('product');
			}

			var finishSelectOrderItem = function() {

				$scope.form.templateName = $scope.currentOrder.orderid + "-" + $scope.currentOrderitem.name;
				$scope.currentOrderitem.orderid = $scope.currentOrder.orderid;
				$scope.currentOrderitem.isFromCreateTemplate = true;

				$scope.form.mainPdtClass = undefined;
				$scope.form.pdtClass = undefined;
				$scope.form.product = undefined;

				// 設個timeout，避免規格init失敗
				$timeout(function() {
					if($scope.isLoaded){
						getOrderItem($scope.currentOrderitem);
						changeViewType('product');
					} else {
						getPdtClassList($scope.currentOrderitem);
					}
				})
			}

			var getOrderItem = function(orderitem) {

                for(var i = 0; i < $scope.pdtClassList.length; i++) {

                    var mainPdtClass = $scope.pdtClassList[i];

                    for(var j = 0; j < mainPdtClass.pdtClasses.length; j++) {

                        var pdtClass = mainPdtClass.pdtClasses[j];

                        if(orderitem.pdtClass == pdtClass.pdtClass) {

                            // 複合商品找法不同
                            if(orderitem.complexidList && orderitem.complexidList.length > 0) {
                                if(getComplexOrderItem(orderitem, mainPdtClass, pdtClass)) {
                                	return;
                                }
                            } else {
                                for(var k = 0; k < pdtClass.products.length; k++) {
                                    var product = pdtClass.products[k];
                                    if(orderitem.productid == product.productid) {
                                        $scope.form.mainPdtClass = mainPdtClass;
                                        $scope.form.pdtClass = pdtClass;
                                        $scope.form.product = product;
                                        $scope.form.specInitOrderitem = orderitem;
                                        return;
                                    }
                                }
                            }                            
                        }
                    }
                }
            }

            var getComplexOrderItem = function(orderitem, mainPdtClass, pdtClass) {

                for(var i = 0; i < pdtClass.products.length; i++) {
                    var product = pdtClass.products[i];

                    if(product.complex && product.complex.productList && product.complex.productList.length > 0) {
                        for(var j = 0; j <  product.complex.productList.length; j++) {
                            var complexPdt = product.complex.productList[j];
                            if(orderitem.productid == complexPdt.productid) {
                                $scope.form.mainPdtClass = mainPdtClass;
                                $scope.form.pdtClass = pdtClass;
                                
                                var _product = shallowCopy(product);

                                complexPdt.name = _product.name;
                                complexPdt.complex = _product.complex;
                                complexPdt.isComplex = _product.isComplex;

                                $scope.form.product = complexPdt;
                                $scope.form.specInitOrderitem = orderitem;
                                return true;
                            }
                        }
                    }
                }

                return false;
            }

			var cancel = function() {

				closeModal();	
			}

			var resetAll = function() {

				resetSelect();
				resetVar();
				$scope.orders.length = 0;
				$scope.start = 0;
				$scope.isOrderLoading = false;
				$scope.isOrderNoMore = false;
				$scope.isOrderEmpty = false;
			}

			var init = function() {

				resetSelect();
				resetVar();

				if(!$scope.isLoaded){
					getPdtClassList();
				}
			}
			
			//==========================
	        //  Events
	        //==========================
	        $scope.$on("LOGOUT_SUCCESS", function(event, data) {
	            
	            resetAll();
	        })

	        $scope.$on("OPEN_CREATE_ORDER_TEMPLATE_MODAL", function(event, data) {

	        	if(data && data.callback) {
	        		$scope.callback = data.callback;
	        	}

	        	init();
	        	changeViewType('product', true);

	        	openModal();
			});

			$scope.$on("OPEN_SELECT_TEMPLATE_FROM_ORDER_MODAL", function(event, data) {

	        	if(data && data.callback) {
	        		$scope.callback = data.callback;
	        	}

	        	init();
	        	changeViewType('orderitem', true);

	        	if($scope.orders.length == 0) {
	        		$scope.isOrderLoading = false;
	        		$scope.isOrderNoMore = false;
	        		$scope.isOrderEmpty = false;
	        		getHistoryOrderList();
	        	}

	        	openModal();
			});

	        //==========================
	        //  Members
	        //==========================
	        $scope.isLoading = false;
	        $scope.isLoaded = false;
	        $scope.pdtClassList = [];

	        $scope.orders = [];
	        $scope.start = 0;
	        $scope.len = 20;
	        $scope.isOrderLoading = false;
	        $scope.isOrderNoMore = false;
	        $scope.isOrderEmpty = false;
	        $scope.isOrderError = false;
	        $scope.currentOrder = undefined;
	        $scope.currentOrderitem = undefined;

	        $scope.form = {
	        	mainPdtClass: undefined,
	        	pdtClass: undefined,
	        	product: undefined,
	        	templateName: undefined,
	        	viewtype: 'product', // orderfile, orderitem
	        	isNoTemplateName: false,
	        	specInitOrderitem: undefined,
	        };

	        $scope.viewWithoutAnimation = false;

	        $scope.selectOrderFileCallback = undefined;

	        //==========================
	        //  Methods
	        //==========================
	        $scope.changeMainPdtClass = changeMainPdtClass;
	        $scope.changePdtClass = changePdtClass;
	        $scope.changeProduct = changeProduct;
	        $scope.templateCallback = templateCallback;
	        $scope.changeSelectOrderView = changeSelectOrderView;
	        $scope.changeViewType = changeViewType;
	        $scope.getOrderItemCoverImage = getOrderItemCoverImage;
	        $scope.getOrderItemFileImage = getOrderItemFileImage;
	        $scope.getHistoryOrderList = getHistoryOrderList;
	        $scope.selectOrder = selectOrder;
	        $scope.selectOrderItem = selectOrderItem;
	        $scope.getDownloadUrl = getDownloadUrl;
	        $scope.finishSelectOrderFile = finishSelectOrderFile;
	        $scope.finishSelectOrderItem = finishSelectOrderItem;
	        $scope.cancel = cancel;

	        //==========================
	        //  Init
	        //==========================

		}]

		_dir.scope = true;
		_dir.restrict = 'E';
		_dir.templateUrl = 'partials/modal/create_order_template.html';
		_dir.link = link;
		_dir.controller = controller;
		
		return _dir;
	}
]);